/**
 * @typedef {Object} ToothStageRawDO
 * @property {number} stageNumber
 * @property {string} toothGumType
 * @property {string} rawType
 * @property {string} fileUrl
 * @property {Array} rawData
 */
import { TOOTH_GUM_TYPE_KEY, TOOTH_RAW_TYPE_KEY, TOOTH_STAGE_NUMBER_KEY } from "../constant/toothConstant";

const toothStageRawDOListSingle = [];
const toothStageRawDOMapSingle = {};


const addToothStageRawDO = (toothStageRawDO) => {
  const stageNumberKey = `${TOOTH_STAGE_NUMBER_KEY}:${toothStageRawDO.stageNumber}`;
  const toothGumTypeKey = `${TOOTH_GUM_TYPE_KEY}:${toothStageRawDO.toothGumType}`;
  const rawTypeKey = `${TOOTH_RAW_TYPE_KEY}:${toothStageRawDO.rawType}`;
  const key = `${stageNumberKey}.${toothGumTypeKey}.${rawTypeKey}`;

  toothStageRawDOMapSingle[key] = toothStageRawDO;
  toothStageRawDOListSingle.push(toothStageRawDO);
};

const getToothStageRawDOList = () => {
  return toothStageRawDOListSingle;
};

const getToothStageRawDOListByRawType = (rawType) => {
  const toothStageRawDOList = toothStageRawDOListSingle.filter((toothStageRawDO) => toothStageRawDO.rawType === rawType);
  return toothStageRawDOList;
};

const getToothStageRawDOByStageNumberAndToothGumTypeAndRawType = (stageNumber, toothGumType, rawType) => {
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE_KEY}:${toothGumType}.${TOOTH_RAW_TYPE_KEY}:${rawType}`;
  return toothStageRawDOMapSingle[key];
};


export default {
  addToothStageRawDO,
  getToothStageRawDOList,
  getToothStageRawDOByStageNumberAndToothGumTypeAndRawType,
  getToothStageRawDOListByRawType,
};
